<template>
  <div class="col-md-3">
    <form-group-input
      ref="input"
      type="text"
      :label="label"
      :disabled="conjugeDisabled"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      v-validate="{ required: (required && !conjugeDisabled), cpf: true }"
    />
  </div>
</template>

<script>
import CPF from "cpf";

export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-cpf-conjuge",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  computed: {
    crm() {
      return this.$store.state.crm;
    }
  },
  asyncComputed: {
    conjugeDisabled() {
      let enabled = this.crm.conjuge;

      return !enabled;
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  created() {
    this.$validator.extend("cpf", {
      getMessage: "O CPF informado é inválido",
      validate: value => {
        return CPF.isValid(value);
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/CpfConjuge.vue